import { Navigate, Outlet, useOutletContext } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import PageLoader from '@/routes/page-loader';
import { paths } from '@/shared/routes/paths';

/**
 * Wrapper that redirects non-admin users to the dashboard.
 * Must be nested inside AuthGuard (assumes authenticated).
 * Forwards the parent outlet context (AppLayout) to child routes.
 */
export default function AdminGuard() {
  const { isAdmin, isLoading } = useAuth();
  const ctx = useOutletContext();

  if (isLoading) return <PageLoader />;

  if (!isAdmin) {
    return <Navigate to={paths.home} replace />;
  }

  return <Outlet context={ctx} />;
}
